export default {"src":"/_next/static/media/deposit_offer_custom_label_gold.e49ae7b8.svg","height":28,"width":78,"blurWidth":0,"blurHeight":0};